var styles = {
  "Popover": "Online-Store-UI-Popover_baa7g",
  "fadein": "Online-Store-UI-Popover--fadein_tp7xr",
  "hidden": "Online-Store-UI-Popover--hidden_tgxmd"
};

export { styles as default };
